import { loader } from 'graphql.macro'

export default async function dismissTermsAndConditionWarning ({ dataLoaders, variables }) {
  const schema = loader('./dismissTermsAndConditionWarning.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      clientTermsAndConditionId: variables.clientTermsAndConditionId
    }
  })
  return response.dismissTermsAndConditionWarning
}
